export enum StatesEmptyResults {
  BUYS = 'buys',
  AUCTIONS = 'auctions',
  TRANSFERS = 'transfers',
}
